import './CRTOverlay.css';

/* ============================================================================
   CRTOverlay — the glass in front of everything.

   Sits above the entire app at --z-crt with pointer-events: none, so it never
   interferes with input. Every layer's strength is driven by the --fx-*
   variables from tokens.css, which the settings toggle rewrites — at fx="off"
   all of these collapse to zero opacity and stop animating.

   Layers, back to front:
     scanlines  — horizontal phosphor line structure
     grille     — vertical RGB triads (aperture grille), very faint
     grain      — animated film noise
     tracking   — a bright bar rolling down the tube like a bad sync
     glass      — vignette, corner darkening, screen curvature highlight
   ========================================================================== */

function CRTOverlay() {
  return (
    <div className="ui-crt" aria-hidden="true">
      <div className="ui-crt__scanlines" />
      <div className="ui-crt__grille" />
      <div className="ui-crt__grain" />
      <div className="ui-crt__tracking" />
      <div className="ui-crt__glass" />
    </div>
  );
}

export default CRTOverlay;
